export default __webpack_public_path__ + "static/media/Espaco_prana_spa.cf05943b.jpg";